import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Home, Flame, RotateCw, Grid3x3, Package, Settings } from 'lucide-react';
import ResourcesPanel from './ResourcesPanel';
import CyclesPanel from './CyclesPanel';
import WorkCentersPanel from './WorkCentersPanel';
import GeneralPanel from './GeneralPanel';
import ProductsPanel from '../produits/ProductsPanel';

export type ReferentielTab = 'cycles' | 'resources' | 'workCenters' | 'products' | 'general';

const TABS: { id: ReferentielTab; label: string; icon: typeof Flame }[] = [
  { id: 'cycles', label: 'Cycles', icon: RotateCw },
  { id: 'resources', label: 'Moyens chauds', icon: Flame },
  { id: 'products', label: 'Produits', icon: Package },
  { id: 'workCenters', label: 'Centres de charge', icon: Grid3x3 },
  { id: 'general', label: 'Général', icon: Settings },
];

/**
 * Ecran de parametrage du referentiel : cycles, moyens, produits, centres de
 * charge. `initialTab` permet d'ouvrir directement un onglet (ex. /produits).
 */
export default function ReferentielView({ initialTab = 'cycles' }: { initialTab?: ReferentielTab }) {
  const [tab, setTab] = useState<ReferentielTab>(initialTab);

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
          <h1 className="text-xl font-bold">Paramétrage — Référentiel</h1>
          <Link to="/" className="flex items-center gap-2 text-blue-100 hover:text-white">
            <Home size={18} /> Accueil
          </Link>
        </div>
        <nav className="max-w-7xl mx-auto px-4 flex gap-1">
          {TABS.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => setTab(id)}
              className={`px-4 py-2 flex items-center gap-2 rounded-t ${
                tab === id ? 'bg-gray-100 text-blue-800 font-medium' : 'text-blue-100 hover:bg-blue-700'
              }`}
            >
              <Icon size={16} /> {label}
            </button>
          ))}
        </nav>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-6">
        {tab === 'cycles' && <CyclesPanel />}
        {tab === 'resources' && <ResourcesPanel />}
        {tab === 'products' && <ProductsPanel />}
        {tab === 'workCenters' && <WorkCentersPanel />}
        {tab === 'general' && <GeneralPanel />}
      </main>
    </div>
  );
}
